
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map, switchMap, distinctUntilChanged, debounceTime} from 'rxjs/operators';
// import { AppConstant } from './../../shared/constant/app.constant';
import { AuthHttp } from '../../admin/services/token.service';
import { Injectable } from '@angular/core';





import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class CustomerRealTimeSearchService {
    constructor(private http: AuthHttp, private appConfigService: AppConfigService) {
        AppConstant = appConfigService;
    }

    // Searching through CASA based on customer type (group, batch, single)

    search(terms: Observable<any>) {

        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.searchEntries(term)),);
    }

    searchEntries(term) {
        return this.http
            .get(`casa/customer/search/${term}`).pipe(
            map((res: any) => res))
    }

    // Searching through Customer table
    searchForCustomer(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.searchForCustomerAccount(term)),);
    }

    searchForCustomerAccount(term) {
        return this.http
            .get(`casa/customer-account/${term}`).pipe(
            map((res: any) => res))
    }

    searchForCustomerGroup(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.searchCustomerGroupEntries(term)),);
    }

    searchCustomerGroupEntries(term) {
        return this.http
            .get(`customers/customer-group/search/?searchQuery=${term}`).pipe(
            map((res: any) => res))
    }


    // working code - others seem to be broken!

    searchForCustomerRealTime(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.searchCustomerRealtime(term)),);
    }
    searchCustomerRealtime(search) {
        return this.http.get(`customer/customer-information/?searchQuery=${search}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
}